export default {
    competitions:[],
    competitionComments:[],
    reportedComments:[],
    defaults:{}
  };
  